<template>
    <div>
        
        <v-col class="text-center" cols="12">
            <v-card outlined class="mt-1" :style="[{'background-color':preguntas[0].color_fondo_titulo}]"> 
                <span class="ma-2 gestor_titulo" v-html="preguntas[0].titulo"></span>
            </v-card> 
            <v-card outlined class="mt-1" :style="[{'background-color':preguntas[0].color_fondo_pregunta}]"> 
                <span class="ma-2 gestor_subtitulo" v-html="preguntas[0].pregunta"></span>
            </v-card>
           
            <!-- PREGUNTA UNICA RESPUESTA-->

            <template v-if="preguntas[0].tipo==='PU'">
                <v-row>
                    <v-col cols="8">
                        <!-- <v-radio-group :mandatory="false" class="ml-12"> -->
                        <v-radio-group class="mt-0"  v-model="pUnica"   :mandatory="false">
                            <!-- <v-alert  border="left" colored-border color="primary" elevation="2" v-for="item of preguntas[0].tareas" :key="item.id">          -->                                   
                            <div class="alertKW " v-for="item of preguntas[0].tareas" :key="item.id">
                                <v-row>
                                    <v-col cols="auto"><v-radio @change="validarPreguntaUnica(item)" :value="item.id"></v-radio></v-col>

                                    <v-col cols="auto" class="texto"><span>{{item.respuesta}}</span></v-col>
                                </v-row>
                            </div>
                            <!-- </v-alert> -->
                               
                        </v-radio-group>
                    </v-col>

                
                   <v-col cols>
                        <transition name="slide-fade" v-if="respuestaUnica">
                            <v-alert :type="estado">
                                <h3>{{larespuesta}}</h3>
                            </v-alert>
                        </transition>
                    </v-col> 
                    
                </v-row>
            </template>


        
            <!-- PREGUNTA MULTIPLE OPCIONES-->
        

            <template v-if="preguntas[0].tipo==='PM'">
                <v-row v-if="opciones" >
                    <v-col cols="9">
                        <div class="alertKW py-0" v-for="item of preguntas[0].tareas" :key="item.id">
                        <!-- <v-alert  border="left" colored-border color="primary" elevation="2" > -->
                            <v-row>
                                <v-col cols="auto" class="py-0"><v-checkbox v-model="correctas" :value="item" ></v-checkbox></v-col>
                                <v-col cols="auto" class="texto"><span>{{item.respuesta}}</span></v-col>
                            </v-row>                                
                        <!-- </v-alert> -->
                        </div>
                    </v-col> 
                </v-row>

                <v-btn class="primary" @click="validarPreguntaMultiple" v-if="validar">Validar</v-btn>

                <v-row v-if="respuestas">
                    <v-col cols>
                        <v-alert type="info">TUS RESPUESTAS</v-alert>
                        <ul>
                            <li v-for="i of  misRespuestas" :key="i.id">
                                <h3 style="color:#43A047;" v-if="i.correcta===true">{{i.respuesta}} <v-icon color="success" class="ml-2">fa-check</v-icon></h3>
                                <h3 style="color:#E53935;" v-else>{{i.respuesta}} <v-icon color="error" class="ml-2">fa-times</v-icon></h3>
                            </li>
                        </ul>
                    </v-col>
                    <v-col cols>
                        <v-alert type="info">OPCIONES</v-alert>
                        <ul>
                            <li v-for="item of preguntas[0].tareas" :key="item.id">
                                <h3 style="color:#43A047;" v-if="item.correcta===true">{{item.respuesta}} <v-icon color="success" class="ml-2">fa-check</v-icon></h3>
                                <h3 style="color:#E53935;" v-else>{{item.respuesta}} <v-icon color="error" class="ml-2">fa-times</v-icon></h3>
                            </li>
                        </ul>
                    </v-col>
                </v-row>
            </template>

    
            <!---RESPUESTA VERDADERO O FALSO -->
        
            <template v-if="preguntas[0].tipo==='PV'">
                <v-row>
                    <v-col cols="8">
                        <v-radio-group class="mt-0" v-model="pVerdadero"  :mandatory="false">
                            <div class="alertKW" v-for="item of preguntas[0].tareas" :key="item.id">
                            <!-- <v-alert  border="left" colored-border color="primary" elevation="2"> -->
                                <v-row>
                                    <v-col cols="auto"><v-radio @change="validarVerdadero(item)" :value="item.id"></v-radio></v-col>
                                    <v-col cols="auto" class="texto"><span>{{item.respuesta}}</span></v-col>
                                </v-row>
                            </div>
                                
                            <!-- </v-alert> -->
                        </v-radio-group>    
                    </v-col>
                    
                    <v-col cols="4">
                        <transition name="slide-fade" v-if="respuestaVerdadera">
                            <v-alert :type="color">
                                <h3>Respuesta: {{tipo}}</h3>
                            </v-alert>
                        </transition>
                    </v-col>
                </v-row>
         
            </template>

        
        </v-col>

    
        <span v-if="test">
            <code>Datos: {{preguntas[0].tareas}}</code>
        </span> 
    


    </div>
</template>



<script>
    import {mapMutations} from 'vuex';
    // import VistaCol01 from '../../../../Academico/Alumno/VistasDiapositivas/VistaCol01.vue';

    export default {
  // components: { VistaCol01 },
        name: 'vistaPreg1',

        props:{
            preguntas:{
                type:Array
            },
            respuestaVerdadera:{
                type:Boolean
            },
            respuestaUnica:{
                type:Boolean
            },
            respuestas:{
                type:Boolean
            },
            opciones:{
                type:Boolean
            },
            validar:{
                type:Boolean
            },
        },

          

        data() {
            return {  
                test:false,
                estado:'',
                volver:false,
                larespuesta:'',
                correctas:[],
                tipo:'',
                color:'',
                misRespuestas:[],
                pUnica: null,
                pVerdadero: null
                
            };
        },
  
 
        mounted() {
            this.limpiarForm()
        },
  


        methods: {
            //  ------- MENSAJE DE SISTEMA  --------
            ...mapMutations('mensajeSis', ['setEnviarMens']),
            ////////////////////////////////////////////////////////

            validarPreguntaUnica(item){
                var tipo = 'prU'
                if(item.correcta===true){

                    this.larespuesta =  "Respuesta Correcta" 
                    this.estado = 'success'
                    this.$emit('comprobar',tipo);
                }else if(item.correcta===false){

                    this.larespuesta = "Respuesta Incorrecta"
                    
                    this.estado = 'error'
                    this.$emit('comprobar',tipo);
                }
            },


            validarPreguntaMultiple(){
                if(this.correctas.length === 0){
                    this.setEnviarMens({tipo:"W", mensaje: "Debe seleccionar al menos una opcion" , tiempo:null})
                }else{
                  var tipo = 'prM'
                    this.$emit('comprobar',tipo);
                    this.volver = true
                    this.validar = false
                    this.misRespuestas = this.correctas
                    this.correctas = []
                }
            },


            validarVerdadero(item){
                if(item.correcta===true){
                    this.respuestaVerdadera = true
                    this.tipo = "Correcta"
                    this.color = "success"
                }else if(item.correcta===false){
                    this.respuestaVerdadera = true
                    this.tipo = "Incorrecta"
                    this.color =  "error"
                }
            },
        

            limpiarForm(){
                // this.respuestaU    = []
                this.correctas     = []
                this.misRespuestas = []
            },


        },
    }
</script>



<style scoped>
    .texto{
        font-size: 22px !important;
    }

    .slide-fade-enter-active {
        transition: all 0.3s ease;
    }

    .slide-fade-leave-active {
        transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for <2.1.8 */ {
        transform: translateX(10px);
        opacity: 0;
    }


    .alertKW{
        border-style: solid;
        border-width:0, 0, 0, 4px; 
    
        background-color:#fff;

        border: 0px ;
        border-left: 8px solid #1565c0;

        box-shadow: 1px 2px 4px 0px #888888;
        
        font-size: 16px;
        margin-bottom: 16px;
        padding: 8px;
        border-radius: 5px;
    }

</style>
